class Workflow {
    constructor() {
        this.AdjList = new Map([]);
    }
    //Adds node to graph & updates adjList and sourceNodes
    addNode(node, sourceNodeList) {
        this.AdjList.set(node, []);
        var adj_list = this.AdjList;
        if (sourceNodeList.length > 0) {
            sourceNodeList = sourceNodeList.map(function (sourceNode) {
                adj_list.get(sourceNode).push(node);
            });
            this.AdjList = adj_list;
        }
    }

    getSources(node) {
        var keys = [...this.AdjList.keys()]
        var sources = []

        keys.forEach(key => {
            var child_nodes = this.AdjList.get(key)
            if (child_nodes.includes(node)) {
                sources.push(key)
            }
        })
        return sources
    }

    traversal_workflow(w_f, start) {
        // 
        var queue = [start];
        var visited = [];
        while (queue.length > 0) {
            var current = queue.shift();
            if (visited.includes(current)) {
                continue;
            }
            visited.push(current);
            var source = this.getSources(current);

            // 
            // 
            var arr = w_f.get(current);
            for (var i = 0; i < arr.length; i++) {
                //Children 
                queue.push(arr[i]);
            }
        }
    }
}

export default Workflow;
